export default {
    order: state => state.orders,
    pre_order: state => state.pre_orders
}